import AssetTabDetails from "./AssetTabDetails";

export default AssetTabDetails;
